/**
 * Critical JavaScript - Loads first on every page
 * Initializes cart state and scroll animations
 */

import { updateCartBubble } from './utilities.js';
import { initScrollAnimations } from './scroll-animations.js';

initScrollAnimations();

function initDuckSocialReveal() {
  const rows = [
    document.querySelector('[id^="row-"][id$="__social_icons_mobile"]'),
    document.querySelector('[id^="row-"][id$="__social_icons_desktop"]'),
  ].filter(Boolean);

  if (!rows.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    rows.forEach((row) => row.classList.add('is-duck-animated'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-duck-animated');
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.35,
      rootMargin: '0px 0px -8% 0px',
    }
  );

  rows.forEach((row) => {
    if (row.dataset.duckRevealInit === 'true') return;
    row.dataset.duckRevealInit = 'true';
    observer.observe(row);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateCartBubble();
  initDuckSocialReveal();
});

// Sitewide details script to ensure no overlap with other same page details containers

